<div class="wrapper">
  <div class="header">
    <ng-content></ng-content>
  </div>
  <div class="body" *ngIf="technicalInfoForm" [formGroup]="technicalInfoForm">
    <mat-tab-group mat-stretch-tabs class="tab-group">
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon
            class="errorIcon"
            *ngIf="
              getErrors([
                insideSurveyInsideInfo.PROXIMUS_EQUIPMENT_SUBTITLE,
                insideSurveyInsideInfo.TELCO_ROOM_SUBTITLE
              ])
            "
            >warning</mat-icon
          >
          <span> Access to telco </span>
        </ng-template>
        <app-access-to-telco
          formControlName="accessToTelco"
          [survey]="survey"
          [isAuthCanWrite]="isAuthCanWrite"
          [pictures]="pictures"
          [camera]="camera"
          [cameraLayer]="cameraLayer"
          [viewerLayer]="viewerLayer"
        ></app-access-to-telco
      ></mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon
            class="errorIcon"
            *ngIf="
              getErrors([
                insideSurveyInsideInfo.CONNECTIONS_CABLING_INFO_SUBTITLE,
                insideSurveyInsideInfo.COPPER_INTROS_SUBTITLE,
                insideSurveyInsideInfo.DESIRED_FIBER_SUBTITLE
              ])
            "
            >warning</mat-icon
          >
          <span
            i18n="
              @@survey.inside.technicalinfo.inside.general.technicalinfo.telco.existing"
            >Existing telco</span
          ></ng-template
        >
        <app-existing-telco
          formControlName="existingTelco"
          [survey]="survey"
          [isAuthCanWrite]="isAuthCanWrite"
          [buildings]="survey.buildings"
          [pictures]="pictures"
          [camera]="camera"
          [cameraLayer]="cameraLayer"
          [viewerLayer]="viewerLayer"
        ></app-existing-telco
      ></mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon
            class="errorIcon"
            *ngIf="
              getErrors([
                insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
                insideSurveyInsideInfo.HORIZONTAL_VERTICAL_INFO_SUBTITLE,
                insideSurveyInsideInfo.VERTICAL_PHOTO_SUBTITLE,
                insideSurveyInsideInfo.ELECTRICITY_OTHER_INFO_SUBTITLE,
                insideSurveyInsideInfo.ELECTRICITY_PHOTO_SUBTITLE
              ])
            "
            >warning</mat-icon
          >
          <span
            i18n="
              @@survey.inside.technicalinfo.inside.general.technicalinfo.generaltechinfo"
            >General technical info</span
          ></ng-template
        >
        <app-general-technical-info
          formControlName="generalInfo"
          [survey]="survey"
          [pictures]="pictures"
          [isAuthCanWrite]="isAuthCanWrite"
          [camera]="camera"
          [cameraLayer]="cameraLayer"
          [viewerLayer]="viewerLayer"
        ></app-general-technical-info
      ></mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span
            i18n="
              @@survey.inside.technicalinfo.inside.general.technicalinfo.specialBuilding"
            >Special Building</span
          >
        </ng-template>
        <app-special-building-info
          formControlName="specialBuilding"
          [isAuthCanWrite]="isAuthCanWrite"
        ></app-special-building-info
      ></mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon
            class="errorIcon"
            *ngIf="
              getErrors([
                insideSurveyInsideInfo.TSA_TECHNICALSOLUTION_NOT_PROVIDED
              ])
            "
            >warning</mat-icon
          >
          <span
            style="width: 70%"
            i18n="
              @@survey.inside.technicalinfo.inside.general.technicalinfo.noAdminTSA"
            >Tech. Solution too complex</span
          ></ng-template
        >
        <app-no-admin-tsa
          formControlName="noAdminTSA"
          [isAuthCanWrite]="isAuthCanWrite"
          [survey]="survey"
        ></app-no-admin-tsa
      ></mat-tab>
    </mat-tab-group>
  </div>
</div>
